// A plain-letter shortcut must yield to real text entry, but NOT to a focused
// button — a letter doesn't activate one, unlike the Space/Enter that
// isEditableOrControlTarget guards against.
export function isTextEntryTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null
  return (
    !!el &&
    (el.tagName === 'INPUT' ||
      el.tagName === 'TEXTAREA' ||
      el.tagName === 'SELECT' ||
      el.isContentEditable)
  )
}
